import DlpPolicyMatchDetail from 'owa-service/lib/contract/DlpPolicyMatchDetail';
import DlpPolicyTipAction from 'owa-service/lib/contract/DlpPolicyTipAction';

export function isOverrideLinkVisible(matchDetail: DlpPolicyMatchDetail): boolean {
    return (
        matchDetail.Action == DlpPolicyTipAction.RejectUnlessSilentOverride ||
        matchDetail.Action == DlpPolicyTipAction.RejectUnlessExplicitOverride
    );
}
